import { ChangePasswordComponent } from './channels/auth/change-password/change-password.component';
import { DeviceRegistrationComponent } from './channels/auth/device-registration/device-registration.component';
import { ForgotUsernameComponent } from './channels/auth/forgot-username/forgot-username.component';
import { AuthGuard } from '@mpt-fo/common/core/services/auth-guard.service';
import { ForgotPasswordComponent } from './channels/auth/forgot-password/forgot-password.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './channels/auth/login/login.component';
import { BiometricComponent } from './channels/auth/biometric/biometric.component';
import { MobileWebViewGuard } from '@mpt-fo/common/core/services/mobile-web-view.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PinComponent } from './pin/pin.component';
import { BusinessPinComponent } from './pin/business-pin/business-pin.component';
import { OtpPinCreationComponent } from './pin/otp-pin-creation/otp-pin-creation.component';
import { PinGetStartedComponent } from './pin/pin-get-started/pin-get-started.component';
import { MobileLoginComponent } from './channels/auth/login/partials/mobile-login/mobile-login.component';
import { WebLoginComponent } from './channels/auth/login/partials/web-login/web-login.component';
import { LinkUserToMobileDeviceComponent } from './channels/auth/login/partials/mobile-login/components/link-user-mobile-device/link-user-to-mobile-device.component';
import { UsernameRecoveryComponent } from './channels/auth/login/partials/mobile-login/components/credential-recovery/partials/username-recovery/username-recovery.component';
import { PasswordRecoveryComponent } from './channels/auth/login/partials/mobile-login/components/credential-recovery/partials/password-recovery/password-recovery.component';
import { SuccessRecoveryComponent } from './channels/auth/login/partials/mobile-login/components/credential-recovery/partials/password-recovery/partials/success-recovery/success-recovery.component';
import { NoInternetConnectionComponent } from './channels/auth/login/partials/mobile-login/components/no-internet-connection/no-internet-connection.component';
import { ChangeMobilePasswordComponent } from './channels/auth/login/partials/mobile-login/components/change-password/change-mobile-password.component';
import { LoginDeviceRegistrationComponent } from './channels/auth/login/partials/login-device-registration/login-device-registration.component';
import { LoginLivenessCheckComponent } from './channels/auth/login/partials/login-liveness-check/login-liveness-check.component';
import { LoginRequestLocationComponent } from './channels/auth/login/partials/login-request-location/login-request-location.component';
import { SplashScreenComponent } from './channels/auth/login/partials/mobile-login/components/splash-screen/splash-screen.component';
import { MobileAppVersionUpgradeComponent } from './channels/auth/login/partials/mobile-login/components/mobile-app-version-upgrade/mobile-app-version-upgrade.component';
import { NeedHelpComponent } from '@mpt-fo/common/kamona/components/need-help/need-help.component';
import { ForgetPasscodeComponent } from "@app/channels/auth/login/partials/forget-passcode/forget-passcode.component";
import { ForgetPasswordComponent } from "@app/channels/auth/login/partials/forget-password/forget-password.component";
import { SignInComponent } from "@app/channels/auth/login/partials/sign-in/sign-in.component";
import {
	UserDeviceRegistrationComponent
} from "@app/channels/auth/login/partials/sign-in/partials/user-device-registration/user-device-registration.component";
import { OnboardingGuard } from '@mpt-fo/common/core/services/onboarding-guard.service';
import { MoniecrmGuard } from './offline-sales/services/moniecrm-guard.service';
import { ReactMfeWrapperComponent } from '@mpt-fo/common/lean-shared/components/react-mfe-wrapper/react-mfe-wrapper.component';
import { ProfileSetupRedirectGuard } from '@mpt-fo/common/core/route-guards/profile-setup-redirect.guard';
import { MfeAccountUpgradeGuard } from '@mpt-fo/common/core/route-guards/mfe-account-upgrade.guard';
import { MfeMarketerOnboardingGuard } from '@mpt-fo/common/core/route-guards/mfe-marketer-onboarding.guard';
import { PosChannelGuard } from './pos-channels/shared/services/pos-channel-guard.service';


const routes: Routes = [
	{ path: 'login', component: LoginComponent },
	{ path: 'sign-in', component: SignInComponent },
	{ path: 'user-device-registration', component: UserDeviceRegistrationComponent },
	{ path: 'login/mobile', component: MobileLoginComponent },
	{ path: 'login/mobile/upgrade', component: MobileAppVersionUpgradeComponent },
	{ path: 'login/mobile/splash-screen', component: SplashScreenComponent },
	{ path: 'login/web', component: WebLoginComponent },
	{ path: 'login/forget-passcode', component: ForgetPasscodeComponent },
	{ path: 'login/forget-password', component: ForgetPasswordComponent },
	{
		path: 'mobile/device-registration',
		component: LinkUserToMobileDeviceComponent,
	},
	{
		path: 'mobile/recovery/username',
		component: UsernameRecoveryComponent,
	},
	{
		path: 'mobile/recovery/password',
		component: PasswordRecoveryComponent,
	},
	{
		path: 'mobile/recovery/recovery-success',
		component: SuccessRecoveryComponent,
	},
	{
		path: 'mobile/change-password',
		component: ChangeMobilePasswordComponent,
	},
	{
		path: 'mobile/no-internet-connection',
		component: NoInternetConnectionComponent,
	},
	{
		path: 'login/web/device-registration',
		component: LoginDeviceRegistrationComponent,
	},
	{
		path: 'login/liveness-check',
		component: LoginLivenessCheckComponent
	},
	{
		path: 'login/location-request-access',
		component: LoginRequestLocationComponent
	},
	{ path: 'login/device-registration', component: DeviceRegistrationComponent },
	{ path: 'biometric-registration', component: BiometricComponent, canActivate: [MobileWebViewGuard] },
	{
		path: 'media-capture',
		loadChildren: () => import('./media-capture/media-capture.module').then((m) => m.MediaCaptureModule),
	},
	{ path: 'password-reset', component: ForgotPasswordComponent },
	{ path: 'recover-password', component: ChangePasswordComponent },
	{ path: 'forgot-username', component: ForgotUsernameComponent },
	{ path: 'need-help', component: NeedHelpComponent },
	{
		path: 'terminal-request',
		loadChildren: () => import('./pos-channels/pos-operations/pos-operations.module').then((m) => m.PosOperationsModule),
	},
	{
		path: 'main-app',
		canActivateChild: [AuthGuard, PosChannelGuard],
		loadChildren: () => import('./main-app/main-app.module').then((m) => m.MainAppModule),
	},
	{
		path: 'brm-compliance',
		loadChildren: () => import('@app/offline-sales/brm-compliance/brm-compliance.module').then((m) => m.BrmComplianceModule),
	},
	{
		path: 'onboarding',
		canActivateChild: [OnboardingGuard, ProfileSetupRedirectGuard],
		loadChildren: () => import('./channels/onboarding/onboarding/onboarding.module').then((m) => m.OnboardingModule),
	},
	{
		path: 'cm-role-selection',
		canActivateChild: [AuthGuard],
		loadChildren: () => import('@app/offline-sales/cm-role-selection/cm-role-selection.module').then((m) => m.CmRoleSelectionModule),
	},
	{
		path: 'onboarding-v2',
		canActivateChild: [OnboardingGuard],
		loadChildren: () => import('./channels/onboarding/onboarding-v2/onboarding-v2.module').then((m) => m.OnboardingV2Module),
	},
	{
		path: 'onboarding-v3',
		canActivateChild: [AuthGuard, MfeAccountUpgradeGuard],
		loadChildren: () => import('./channels/mfe-account-upgrade/mfe-account-upgrade.module').then((m) => m.MfeAccountUpgradeModule),
	},
	{
		path: 'kyc',
		canActivateChild: [OnboardingGuard],
		loadChildren: () => import('./kyc/kyc.module').then((m) => m.KycModule),
	},
	{
		path: 'user',
		loadChildren: () => import('./post-login-operations/post-login-operations.module').then((m) => m.PostLoginOperationsModule),
	},
	{
		path: 'pin',
		component: PinComponent,
		children: [
			{
				path: 'business-pin',
				component: BusinessPinComponent,
			},
			{
				path: 'otp',
				component: OtpPinCreationComponent,
			},
		],
	},
	{
		path: 'pin-get-started',
		component: PinGetStartedComponent,
	},
	{
		path: 'staff-user-onboarding',
		loadChildren: () => import('@app/staff-user-onboarding/staff-user-onboarding.module').then((m) => m.StaffUserOnboardingModule),
	},
	{
		path: 'track-dispute',
		loadChildren: () => import('@app/cards/dispute-external-view/dispute-external-view.module').then((m) => m.DisputeExternalViewModule),
	},
	{
		path: 'nibss-bvn-verification',
		loadChildren: () => import('@app/channels/onboarding/nibss-bvn-verification/nibss-bvn-verification.module').then((m) => m.NibssBvnVerificationModule),
	},
	{
		path: 'partners',
		loadChildren: () => import('@app/channels/onboarding/bvn-verification/bvn-verification.module').then((m) => m.BvnVerificationModule),
	},
	{
		path: 'account-statement',
		loadChildren: () => import('@app/accounts/account-statement/account-statement.module').then((m) => m.AccountStatementModule),
	},
	{
		path: 'join',
		loadChildren: () => import('@app/referrals-pre-registration/referrals-pre-registration.module').then((m) => m.ReferralsPreRegistrationModule),
	},
	{
		path: 'activations',
		canActivateChild: [OnboardingGuard],
		loadChildren: () => import('./offline-sales/partners-onboarding/partners-onboarding.module').then((m) => m.PartnersOnboardingModule),
	},
	{
		path: 'moniecrm',
		canActivate: [MoniecrmGuard],
		children: [
			{
				path: '**',
				component: ReactMfeWrapperComponent,
				data: { mfeName: 'moniecrm' },
			},
		],
	},
	{
		path: 'consumer/activate',
		canActivateChild: [MfeMarketerOnboardingGuard],
		children: [
			{
				path: '**',
				component: ReactMfeWrapperComponent,
				data: { mfeName: 'marketerOnboarding' },
			},
		],
	},
	{ path: '', redirectTo: 'login', pathMatch: 'full' },
	{ path: '404', component: PageNotFoundComponent },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
	exports: [RouterModule],
})
export class AppRoutingModule { }
